import { useState, type FormEvent } from "react";
import { ErreurApi } from "../api/client";
import { Message } from "../composants/Elements";
import { useSession } from "../session";

export function PageConnexion() {
  const { connecter, confirmer } = useSession();
  const [courriel, setCourriel] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  // Preuve du mot de passe, à échanger contre le code du second facteur.
  const [preuve, setPreuve] = useState<string | null>(null);
  const [code, setCode] = useState("");
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(evenement: FormEvent) {
    evenement.preventDefault();
    setErreur(null);
    setEnCours(true);
    try {
      if (preuve != null) {
        await confirmer(preuve, code);
      } else {
        const suite = await connecter(courriel, motDePasse);
        if (suite != null) setPreuve(suite.preuve);
      }
    } catch (echec) {
      setErreur(
        echec instanceof ErreurApi
          ? echec.message
          : "La connexion n'a pas abouti. Vérifier que l'application est démarrée.",
      );
    } finally {
      setEnCours(false);
    }
  }

  return (
    <div className="connexion">
      <form onSubmit={soumettre}>
        <h1>Mizane</h1>
        <p className="sous-titre">Comptabilité multi-référentiel</p>

        {erreur != null && <Message type="erreur">{erreur}</Message>}

        {preuve != null ? (
          <>
            <p>Saisir le code à six chiffres affiché par votre application d'authentification.</p>
            <label htmlFor="code">Code</label>
            <input
              id="code"
              inputMode="numeric"
              autoComplete="one-time-code"
              autoFocus
              maxLength={7}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/[^0-9 ]/g, ""))}
              required
            />
            <button type="submit" className="principal" disabled={enCours}>
              {enCours ? "Vérification…" : "Valider le code"}
            </button>
            <button
              type="button"
              className="tertiaire"
              onClick={() => {
                setPreuve(null);
                setCode("");
              }}
            >
              Revenir
            </button>
          </>
        ) : (
          <>
        <label htmlFor="courriel">Adresse de courriel</label>
        <input
          id="courriel"
          type="email"
          autoComplete="username"
          value={courriel}
          onChange={(e) => setCourriel(e.target.value)}
          required
        />

        <label htmlFor="motDePasse">Mot de passe</label>
        <input
          id="motDePasse"
          type="password"
          autoComplete="current-password"
          value={motDePasse}
          onChange={(e) => setMotDePasse(e.target.value)}
          required
        />

        <button type="submit" className="principal" disabled={enCours}>
          {enCours ? "Connexion…" : "Se connecter"}
        </button>
          </>
        )}
      </form>
    </div>
  );
}
